import * as tagUtils from '../../util/tag_utils'

const getColor = (teamName) => teamName === "Olio Apps" ? '#102234' : tagUtils.genColor(teamName)


export function prepSigilMeta(team, sigilMeta) {
    if (sigilMeta) {
        return sigilMeta
    }

    const teamColor = team && (team.color || getColor(team.name))
    const teamName = team ? team.name : ""
    return teamName && !team.isPersonal ?
        {name: teamName[0].toUpperCase(), color: teamColor , teamName: team.name, img: null} : undefined
}




// WEBPACK FOOTER //
// ./src/common/components/team_sigil.js